import { memo, useContext, useState, useMemo } from "react";
import { useDrag, useDrop } from "react-dnd";
import { ItemTypes } from "./itemTypes";
import {
  Box,
  useColorModeValue,
  Text,
  Flex,
  IconButton,
  Icon,
  theme,
  useMediaQuery,
  Image,
  Grid,
  Tooltip,
  Tag,
} from "@chakra-ui/react";
import { format } from "date-fns";
import { RiCloseFill } from "react-icons/ri";
import { AiFillTwitterCircle } from "react-icons/ai";
import { AiOutlineTwitter } from "react-icons/ai";
import { BiPauseCircle } from "react-icons/bi";
import { AiFillEye, AiFillEdit, AiFillLinkedin } from "react-icons/ai";
import { useSession } from "next-auth/react";
import { TweetContext } from "../../context/tweetContext";
import { unschedule } from "../../controllers/schedule";
import {
  convertToAccountTimezone,
  convertToAccountTimezoneReversed,
} from "../../utils/helpers";
import { getAccount, getAuthUrl } from "../../utils/sessionHelper";
import { border } from "theme/foundations/border";
import { radius } from "theme/foundations/radius";
import { text as textTheme } from "theme/foundations/text";
import { textStyle } from "theme/names";
import { useMiscellaneousContext } from "context/miscellaneousContext";

// prettier-ignore
//@ts-ignore
export const Card = memo(function Card({ id, card, text, moveCard, findCard, hoverCard, isHovered, time, openTweet }) {
  // export const Card = ({ id, text, moveCard, findCard }) => {

  const { data: session } = useSession() ?? {}
  const tweetContext: any = useContext(TweetContext);
  const [isTooSmall] = useMediaQuery("(max-width: 800px)");
  const [isLoadingEdit, setIsLoadingEdit] = useState(false);
  const miscellaneousContext: any = useMiscellaneousContext();

  // console.log("id: " + id);
  const originalIndex = findCard(id);
  // const originalIndex = 1;
  // const originalCard = {...card};
  // const originalCard = card.id;

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: card.isEvergreen ? "evergreen" : ItemTypes.CARD,
      item: { id, originalIndex },
      canDrag: (props) => (card.tweet ? true : false),
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      end: (item, monitor) => {
        const { id: droppedId, originalIndex } = item;
        const didDrop = monitor.didDrop();
        if (!didDrop) {
          // moveCard(item.id, originalIndex);
        } else {
          moveCard(item.id);
        }
      },
    }),
    [id, originalIndex, moveCard]
  );

  const [, drop] = useDrop(
    //@ts-ignore
    () => ({
      accept: ItemTypes.CARD,
      canDrop: () => false,
      hover({ id: draggedId }) {
        if (draggedId !== id) {
          // const { index: overIndex } = findCard(id);
          const slotOver = findCard(id);
          // moveCard(draggedId, slotOver);
          hoverCard(slotOver);
        }
      },
    }),
    [findCard, moveCard]
  );

  const getIcon = () => {
    let icon;
    if (card.isEvergreen) icon = <>🌲</>;
    // else if (card?.tweet?.text?.includes("\n\n\n"))
    //     icon = (<>🧵</>)
    else if (card?.tweet)
      icon = (
        <></>
        // <Box pt={2}>
        //   <Icon as={AiFillLinkedin} fontSize="xl" color="#38A1D6" />
        // </Box>
      );

    return <Box>{icon}</Box>;
  };

  const tweetLabels = useMemo(() => getAccount(session)?.tweetLabels, [session, miscellaneousContext.refreshLabels]);
  const label = tweetLabels?.find(l => l.id === card?.labels?.[0])
  const labelsLinkedToTweet = tweetLabels?.filter(l => card?.tweet?.labels?.includes(l.id));

  const textWithoutImages =
    card?.tweet?.text?.replace(/(?:\[img:)(.*?)(?=\])]/g, "") ??
    card?.tweet?.text ??
    "";

  const isNextSlot = time?.getTime() == tweetContext?.nextSlot?.getTime();

  const opacity = isDragging ? 0 : 1;

  let bgColorDefault = useColorModeValue("white", "#1E1E1E");
  // let bgColorEvergreen = useColorModeValue("green.50", "green.900");
  let bgColorHovered = useColorModeValue(
    "border.lightMode.hover",
    "border.darkMode.hover"
  );
  let bgColorSlot = useColorModeValue(
    "background.lightMode.disabled",
    "background.darkMode.disabled"
  );
  // let bgColorTweet = useColorModeValue(
  //   theme.colors.gray[300],
  //   theme.colors.gray[600]
  // );
  // let colorEye = useColorModeValue("gray.600", "gray.100");

  let style: any = {
    bg: bgColorDefault,
  };

  if (card.isEvergreen) {
    // style.bg = bgColorEvergreen;
  } else if (isHovered) {
    style.bg = bgColorHovered;
  } else if (!card.tweet) {
    style.bg = bgColorSlot;
    // style.border = "1px " + bgColorTweet;
  }

  return (
    <Flex
      borderRadius={radius.lg}
      mb={2}
      p={2}
      opacity={opacity}
      alignItems="center"
      h="50px"
      cursor={!card.isEvergreen && card.tweet ? "move" : "pointer"}
      ref={(node) => drag(drop(node))}
      {...border.default.light}
      {...style} // bg
      {...textTheme.body.medium.light.light}
      _hover={{
        boxShadow: card.tweet
          ? "0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08)"
          : "none",
      }}
      _dark={{
        ...border.default.dark,
        ...textTheme.body.medium.light.dark,
      }}
      onClick={() => {
        console.log("card clicked");
        if (card.tweet) {
          openTweet(card.tweet);
        } else {
          let newTime = new Date(card.time);
          // let newTimeTimezoned = convertToAccountTimezone(newTime, getAccount(session)?.timezone).date;
          console.log("newTime: " + newTime);
          // console.log("newTimeTimezoned: " + newTimeTimezoned);
          tweetContext.open();
          tweetContext.setNextSlot(newTime);
          // console.log(tweetContext.textState);
          let textState =
            tweetContext?.textState ??
            tweetContext?.refComposer?.current?.textState();
          tweetContext.setTextState({
            ...textState,
            scheduledTime: newTime,
          });
          // tweetContext.refComposer.current.textState()
          // console.log("set scheduledTime to " + card.time);
        }
      }}
    >
      {/* time */}
      {/* <Flex
        alignItems="center"
        // maxW="80%"
      > */}
      {/* icon */}
      {card.tweet && (
        <Grid
          {...{
            display: ["none", "grid"], // hide on very small screens
            h: "32px",
            w: "32px",
            minW: "32px",
            bg: "primary.lightMode.100",
            _dark: {
              bg: "primary.darkMode.100",
            },
            borderRadius: radius.sm,
            fontSize: "14px",
            placeContent: "center",
          }}
        >
          <Icon {...{ viewBox: "0 0 14 15" }}>
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 7.75C14 11.6328 10.8555 14.75 7 14.75C3.11719 14.75 0 11.6328 0 7.75C0 6.30078 0.4375 4.96094 1.20312 3.83984C1.39453 3.53906 1.80469 3.45703 2.10547 3.64844C2.40625 3.86719 2.48828 4.27734 2.26953 4.57812C1.66797 5.48047 1.28516 6.57422 1.28516 7.75C1.28516 10.8945 3.85547 13.4375 6.97266 13.4375C10.1172 13.4375 12.6875 10.8945 12.6875 7.75C12.6875 4.85156 10.4727 2.44531 7.65625 2.11719V3.59375C7.65625 3.97656 7.35547 4.25 6.97266 4.25C6.61719 4.25 6.31641 3.97656 6.31641 3.59375V1.40625C6.31641 1.05078 6.61719 0.75 6.97266 0.75C10.8555 0.75 14 3.89453 14 7.75ZM7.4375 7.28516C7.71094 7.55859 7.71094 7.96875 7.4375 8.21484C7.19141 8.48828 6.78125 8.48828 6.53516 8.21484L4.34766 6.02734C4.07422 5.78125 4.07422 5.37109 4.34766 5.09766C4.59375 4.85156 5.00391 4.85156 5.25 5.09766L7.4375 7.28516Z"
                fill="#0A66C2"
              />
            </svg>
          </Icon>
        </Grid>
      )}
      <Text textStyle={textStyle["body.medium.light"]} w="80px" minW="80px" ml={card.tweet ? [2, 4] : ["8px", "48px"]}>
        {format(time, "hh:mm aaa")}
      </Text>
      {getIcon()}
      {card?.tweet?.idCompany && (
        <Flex ml={2} p={1} h={8} w={8} minW={8} display={["none", "grid"]}>
          <Image rounded="full" src={card.tweet.image} />
        </Flex>
      )}
      {card.tweet && (
        <Text textStyle={textStyle["body.medium.light"]}
          ml={card?.tweet?.idCompany ? 2 : 4}
          mr={12}
          flex={1}
          noOfLines={1}
          wordBreak={"break-all"}
          {...textTheme.body.medium.standard.light}
          _dark={{
            ...textTheme.body.medium.standard.dark,
          }}
        >
          {textWithoutImages}
        </Text>
      )}
      {/* {card.isEvergreen && (
          <Text textStyle={textStyle["body.medium.light"]}
            fontWeight="600"
            ml={6}
            mr={6}
            maxW={"60%"}
            overflow="hidden"
            noOfLines={1}
            wordBreak={"break-all"}
          >
            Evergreen slot
          </Text>
        )} */}
      {/* {!card.tweet && ( */}
      {isNextSlot && (
        <Text textStyle={textStyle["body.medium.light"]}
          as="i"
          ml={[0, "40px"]}
          // maxW={"80%"}
          overflow="hidden"
          noOfLines={1}
          wordBreak={"break-all"}
          // display={["none", "grid"]} // hide on very small screens
          {...textTheme.body.medium.light.light}
          _dark={{
            ...textTheme.body.medium.light.dark,
          }}
        >
          Press "Add to queue" to place your post here
        </Text>
      )}
      {/* </Flex> */}
      {
        label && !card.tweet && (
          <Flex w="100%" justifyContent="flex-end">
            <Tag mr={1} variant="outline" colorScheme={label.color}>{label.title}</Tag>
          </Flex>
        )
      }
      {card.tweet && (
        <>
          {!isTooSmall && labelsLinkedToTweet?.length > 0 && (
            <Flex mr="2">
              {labelsLinkedToTweet.map(l => <Tag key={l.id} mr={2} variant="outline" colorScheme={l.color}>{l.title}</Tag>)}
            </Flex>
          )}
          {!isTooSmall && (
            <Tooltip hasArrow label="Preview">
              <IconButton
                aria-label="Preview"
                // color="twitter.600"
                variant="action"
                size="table"
                mr={2}
                onClick={async (e) => {}}
                icon={
                  <Icon fontSize="22px">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 12C8 9.8125 9.78125 8 12 8C14.1875 8 16 9.8125 16 12C16 14.2188 14.1875 16 12 16C9.78125 16 8 14.2188 8 12ZM12 14.5C13.375 14.5 14.5 13.4062 14.5 12C14.5 10.625 13.375 9.5 12 9.5C11.9688 9.5 11.9375 9.5 11.9062 9.5C11.9688 9.6875 12 9.84375 12 10C12 11.125 11.0938 12 10 12C9.8125 12 9.65625 12 9.5 11.9375C9.5 11.9688 9.5 12 9.5 12C9.5 13.4062 10.5938 14.5 12 14.5ZM5.96875 7.53125C7.4375 6.15625 9.46875 5 12 5C14.5 5 16.5312 6.15625 18 7.53125C19.4688 8.875 20.4375 10.5 20.9062 11.625C21 11.875 21 12.1562 20.9062 12.4062C20.4375 13.5 19.4688 15.125 18 16.5C16.5312 17.875 14.5 19 12 19C9.46875 19 7.4375 17.875 5.96875 16.5C4.5 15.125 3.53125 13.5 3.0625 12.4062C2.96875 12.1562 2.96875 11.875 3.0625 11.625C3.53125 10.5 4.5 8.875 5.96875 7.53125ZM12 6.5C9.9375 6.5 8.28125 7.4375 7 8.625C5.78125 9.75 4.96875 11.0625 4.53125 12C4.96875 12.9375 5.78125 14.2812 7 15.4062C8.28125 16.5938 9.9375 17.5 12 17.5C14.0312 17.5 15.6875 16.5938 16.9688 15.4062C18.1875 14.2812 19 12.9375 19.4375 12C19 11.0625 18.1875 9.75 16.9688 8.625C15.6875 7.4375 14.0312 6.5 12 6.5Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Icon>
                }
              />
            </Tooltip>
          )}
          <Tooltip hasArrow label="Edit">
            <IconButton
              aria-label="Edit"
              variant="action"
              size="table"
              // size="sm"
              isLoading={isLoadingEdit}
              onClick={async (e) => {
                e.stopPropagation();
                setIsLoadingEdit(true);
                await unschedule(session, card.tweet, tweetContext);
                setIsLoadingEdit(false);
                tweetContext.open();
              }}
              icon={
                <Icon fontSize="22px">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.6562 4.78125C16.5312 3.90625 17.9375 3.90625 18.8125 4.78125L19.2188 5.1875C20.0938 6.0625 20.0938 7.46875 19.2188 8.34375L13.0312 14.5312C12.7812 14.7812 12.4375 15 12.0625 15.0938L8.9375 16C8.6875 16.0625 8.40625 16 8.21875 15.7812C8 15.5938 7.9375 15.3125 8 15.0625L8.90625 11.9375C9 11.5625 9.21875 11.2188 9.46875 10.9688L15.6562 4.78125ZM17.75 5.84375C17.4688 5.5625 17 5.5625 16.7188 5.84375L15.7812 6.75L17.25 8.21875L18.1562 7.28125C18.4375 7 18.4375 6.53125 18.1562 6.25L17.75 5.84375ZM10.3438 12.3438L9.8125 14.1875L11.6562 13.6562C11.7812 13.625 11.875 13.5625 11.9688 13.4688L16.1875 9.25L14.75 7.8125L10.5312 12.0312C10.4375 12.125 10.375 12.2188 10.3438 12.3438ZM10.25 6C10.6562 6 11 6.34375 11 6.75C11 7.1875 10.6562 7.5 10.25 7.5H6.75C6.03125 7.5 5.5 8.0625 5.5 8.75V17.25C5.5 17.9688 6.03125 18.5 6.75 18.5H15.25C15.9375 18.5 16.5 17.9688 16.5 17.25V13.75C16.5 13.3438 16.8125 13 17.25 13C17.6562 13 18 13.3438 18 13.75V17.25C18 18.7812 16.75 20 15.25 20H6.75C5.21875 20 4 18.7812 4 17.25V8.75C4 7.25 5.21875 6 6.75 6H10.25Z"
                      fill="currentColor"
                    />
                  </svg>
                </Icon>
              }
            />
          </Tooltip>
        </>
      )}
    </Flex>
  );
});
